<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('系列名称')" prop="name">
        <a-input v-model="form.name" :maxLength="32" :placeholder="$t('请输入')+$t('系列名称')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('所属品牌')" prop="brandId">
        <a-select v-model="form.brandId" :placeholder="$t('请选择')+$t('所属品牌')" allow-clear>
          <a-select-option v-for="item in brandList" :key="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('系列图片')" prop="pic">
        <oss-upload-single :height="100" :width="100" v-model="form.pic" prefix="goods" type="img"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" :max="21474836" style="width: 100%" :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('系列描述')" prop="remark">
        <a-input v-model="form.remark" :maxLength="100" :placeholder="$t('请输入')+$t('系列描述')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSeries, addSeries, updateSeries } from '@/api/goods/series'
import {mapGetters} from 'vuex'
import OssUploadSingle from "@/components/OssUploadSingle/index.vue"

export default {
  name: 'CreateForm',
  props: {
    brandList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        name: null,
        brandId: undefined,
        pic: null,
        sort: 0,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
        name: [{ required: true, message: '系列名称不能为空', trigger: 'blur' }],
        brandId: [{ required: true, message: '请选择所属品牌', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        brandId: undefined,
        pic: null,
        sort: 0,
        remark: null
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSeries({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSeries(this.form).then(response => {
              this.$message.success(this.$t('修改成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSeries(this.form).then(response => {
              this.$message.success(this.$t('新增成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
